const API_URL = (import.meta.env.VITE_CHAT_API_URL || '').replace(/\/+$/, '');
const API_KEY = import.meta.env.VITE_CHAT_API_KEY || '';

interface ChatResponse {
  reply: string;
  session: {
    msgCount: number;
    tokenCount: number;
  };
}

export async function sendMessage(
  message: string,
  sessionId: string,
  lang: string,
): Promise<ChatResponse> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (API_KEY) headers['x-api-key'] = API_KEY;

  const response = await fetch(`${API_URL}/chat`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ message, sessionId, lang }),
  });

  if (response.status === 429) {
    throw new Error('RATE_LIMITED');
  }

  if (!response.ok) {
    throw new Error('CHAT_ERROR');
  }

  return response.json();
}
